import { Link } from '@remix-run/react';
import cx from 'classnames';

import { Image } from '~/components/Image';
import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';

interface Props {
  url: string;
  name: string;
  textColor: string;
  fontFamily: string;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const LogoHome = ({ url, name, textColor, fontFamily }: Props) => {
  const { webTheme: theme, classes } = useWebThemeContext();

  return (
    <Link className={cx(classes.radius, 'transition:all px-2 py-1 hover:bg-black/5')} to="/">
      <div className="flex items-center space-x-2">
        {url && (
          <div className="w-8 h-8 overflow-hidden rounded-wt">
            <Image
              className="object-contain w-full h-full rounded-wt"
              src={url}
              alt={`${name} logo`}
              maxWidth={100}
              aspectRatio="square"
            />
          </div>
        )}
        <Typography
          as="span"
          color={textColor}
          fontFamilyv2={theme.navbar_font_family}
          className="hidden text-sm sm:text-md wt-text-primary md:block"
        >
          {name}
        </Typography>
      </div>
    </Link>
  );
};

export default LogoHome;
